import { axiosClient } from "shared/axiosInstance";

class LocationCenterService {
  constructor(token, dispatch) {
    this.token = token;
    this.dispatch = dispatch;
  }

  async getCountryRegions(country) {
    return axiosClient(this.dispatch, this.token).get(
      `/location-center/regions`,
      {
        params: {
          country,
        },
      },
    );
  }

  async getCountryRegionTowns(country, region) {
    return axiosClient(this.dispatch, this.token).get(
      `/location-center/regions/towns`,
      {
        params: {
          country,
          region,
        },
      },
    );
  }
}

export default LocationCenterService;
